export const contactUsInitialState = {
  error: {},
  data: {},
  loading: true,
  btnLoading:false,
};
